import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__collection_image_add } from '@shared/dto/collection/_requests/DTO_REQUEST__collection_image_add';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__collections } from '../STATE__collections';

export const REMOTE__collection_image_add = createAsyncThunkSafe<void, DTO_REQUEST__collection_image_add[]>(
  ENUM__network_event_client_to_server.COLLECTION__IMAGE_ADD,
  async (requests: DTO_REQUEST__collection_image_add[]): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.COLLECTION__IMAGE_ADD, requests);
  },
);

export function INIT_REMOTE__collection_image_add(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(REMOTE__collection_image_add.pending, (state, action) => {})
    .addCase(REMOTE__collection_image_add.rejected, (state, action) => {})
    .addCase(REMOTE__collection_image_add.fulfilled, (state, action: PayloadAction) => {});
}
